module.exports = __webpack_public_path__ + "static/img/logo_green.efcf6ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_green.png
// module id = nEdn
// module chunks = 1